import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // get all market place products
  get_market_place_products: async ({ commit }, payload) => {
    
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const { limit, page, sellerId, search, verifiedSeller, categoryId, cityId, weightType, cbd, thc, terpenoidPotency, roomType, plantStage, growMethod } = payload

      const res = await axios.get('/market-place/store', {
        params: {
          limit,
          page,
          sellerId,
          search,
          verifiedSeller,
          categoryId,
          cityId,
          weightType,
          cbd,
          thc,
          terpenoidPotency,
          roomType,
          plantStage,
          growMethod
        }
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'products',
        data: res.data.data
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'filteredCount',
        data: res.data.FilteredCount
      })

      if (res.data.seller) {
        commit('SET_STATE', {
          action: 'seller',
          data: res.data.seller
        })
      }

      return {
        data: res.data.data,
        total: res.data.totalCount,
        seller: res.data.seller
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get specific products detail
  get_market_place_product_by_id: async ({ commit }, id) => {

    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {

      const res = await axios.get(`/market-place/${id}/product-detail`)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'product',
        data: res.data.product
      })
      
      if (res.data.productImages) {
        commit('SET_STATE', {
          action: 'productImages',
          data: res.data.productImages
        }) 
      }

      commit('SET_STATE', {
        action: 'sellers_total_product',
        data: res.data.totalProductCount
      })

      commit('SET_STATE', {
        action: 'similar_products',
        data: res.data.similar_product
      })

      return {
        product: res.data.product,
        similar_products: res.data.similar_product
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // send message to seller
  send_message_to_seller: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {

      const res = await axios.post('/market-place/send-message', payload)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return res.data
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}